import React, { useState } from 'react';
import './App.css'; 

const CreateAdmin = () => {
  const [step, setStep] = useState(1); // Step 1: Form, Step 2: OTP
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- STEP 1: JUST SEND OTP (DON'T SAVE DATA YET) ---
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      // 🔴 UPDATED: Using a dedicated OTP endpoint first
      // Backend ko yahan sirf OTP generate karna chahiye, User save nahi karna chahiye
      const response = await fetch('https://antarvaani.com/api/admin/generate-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email }) 
      });

      const data = await response.text();
      
      if (response.ok) {
        setMessage("OTP Sent to " + formData.email);
        setStep(2); // Move to OTP Screen
      } else {
        // Fallback: Agar upar wala endpoint nahi hai to purana flow use karein
        // Lekin 'Cancel' button par delete logic lagana padega
        setError("Error sending OTP: " + data);
      }
    } catch (err) {
      console.log(err);
      // Agar 'generate-otp' endpoint nahi bana hai to user ko batayein
      setError("Server Error. Ensure backend has /generate-otp endpoint.");
    }
  };

  // --- STEP 2: VERIFY OTP & SAVE DATA ---
  const handleVerifyOtp = async () => {
    try {
      // 🔴 UPDATED: Sending FULL DATA here so user is saved only after verification
      const response = await fetch('https://antarvaani.com/api/admin/create-verified-admin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.username,
          email: formData.email,
          password: formData.password,
          otp: otp // Sending OTP along with data
        })
      });

      const data = await response.text();

      if (response.ok) {
        alert("✅ New Admin Created Successfully!");
        window.location.href = '/admin'; // Redirect to Dashboard
      } else {
        setError(data);
      }
    } catch (err) {
      setError("Verification Failed or Email already exists.");
    }
  };

  // 🔴 NEW: HANDLE CANCEL (Reset Form)
  const handleCancel = () => {
      setStep(1);
      setOtp('');
      setMessage('');
      setError('');
      // Kyunki humne data Step 1 mein save nahi kiya, 
      // toh cancel karne par database mein koi kachra nahi bachega.
  };

  return (
    <div className="loginsignup"> 
      <div className="loginsignup-container" style={{maxWidth:'500px'}}>
        
        {step === 1 ? (
          /* --- FORM UI --- */
          <>
            <h1>Create New Admin</h1>
            <p style={{color:'#666', fontSize:'0.9rem', marginBottom:'20px'}}>
              Add a new administrator. Verify email to create account.
            </p>
            
            <form onSubmit={handleSendOtp} className="loginsignup-fields">
              <input type="text" name="username" placeholder="Admin Name" value={formData.username} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
              <input type="password" name="password" placeholder="Create Password" value={formData.password} onChange={handleChange} required />
              <input type="password" name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required />
              
              <button type="submit">Send Verification OTP</button>
            </form>
          </>
        ) : (
          /* --- OTP UI --- */
          <>
            <h1>Verify Email</h1>
            <p style={{marginBottom:'20px'}}>Enter the OTP sent to <b>{formData.email}</b></p>
            
            <div className="loginsignup-fields">
              <input 
                type="text" 
                placeholder="Enter 6-Digit OTP" 
                value={otp} 
                onChange={(e) => setOtp(e.target.value)} 
                maxLength="6"
                style={{textAlign:'center', letterSpacing:'5px', fontSize:'1.2rem'}}
              />
              <button onClick={handleVerifyOtp} style={{background:'#2e7d32'}}>Verify & Create Admin</button>
              
              {/* 🔴 Updated Cancel Button */}
              <button onClick={handleCancel} style={{background:'#ccc', color:'black', marginTop:'10px'}}>Cancel</button>
            </div>
          </>
        )}

        {/* Messages */}
        {message && <p style={{color:'green', marginTop:'15px', fontWeight:'bold'}}>{message}</p>}
        {error && <p style={{color:'red', marginTop:'15px', fontWeight:'bold'}}>{error}</p>}
        
      </div>
    </div>
  );
};

export default CreateAdmin;